import { create } from "zustand";

export const useAssistant = create((set) => ({
  open: false,
  seed: null,
  setOpen: (open) => set({ open }),
  openWith: (seed) => set({ open: true, seed }),
  clearSeed: () => set({ seed: null }),
}));

export function getAssistantSessionId() {
  let sid = sessionStorage.getItem("noxway_sid");
  if (!sid) {
    sid = crypto.randomUUID();
    sessionStorage.setItem("noxway_sid", sid);
  }
  return sid;
}
